import React, {ReactElement, useState} from 'react';
import {
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  Grid,
  useTheme,
  Box
} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {useSnackbar} from 'notistack';
import {useTranslation} from 'react-i18next';
import {Controller, useForm} from 'react-hook-form';
import {debounce} from 'lodash';
import {
  getRoleList,
  getUserGroupList,
  getUserGroupRolesData,
  updateUserGroupRolesData,
  addNewGroup,
  validateDeleteGroup,
  deleteGroup,
  getADGroupsList,
  syncUserGroups,
  getApplicationListData
} from '@shared/services/service-handlers/PrivateService';

import ComponentLoader from '@components/loaders/component-loader/ComponentLoader';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import ActionModalDialog from '@components/dialog/action-dialog/ActionModalDialog';
import {
  ComponentLoaderGrid,
  UserGroupsGrid,
  RightGrid,
  TopActionGrid,
  ActionButtonGrid,
  RoleNameTypographyGrid,
  RoleAndPermissionsWrapperGrid,
  RoleAndPermissionsLoaderContainerGrid,
  RoleAndPermissionsContainerGrid,
  NoRoleAndPermissionsContainerGrid,
  RoleGrid,
  RoleItemGrid,
  DetailsGrid,
  ButtonsGrid,
  UserGroupListLoaderGrid,
  AdGroupGrid,
  UserGroupListContainer
} from '../modules-menu/user-groups/UserGroupsStyles';
import {LoadingButton} from '@mui/lab';
// import Theme from 'src/styles/theme';
import {APP} from 'src/styles/variables';
import Search from '@components/search/Search';
import {
  BASE_ROUTE,
  BASE_ROUTE_MODULE,
  UAM,
  USER_ACCESS
} from 'src/routes/BaseRoute';
import FormConstants from '@shared/constants/FormConstants';
import AuthUtils from 'src/utils/AuthUtils';
import TextInput from '@components/form/text-input/text-input/TextInput';
import {NEW_GROUP_NAME} from '@shared/constants/RolesComponent';
import AdGroupsAddDialog from '@components/dialog/ad-groups-add-create-dialog/AdGroupsAddDialog';
import {useAppContext} from '@context/AppContext';
import Stack from '@mui/material/Stack';
import Card from '@mui/material/Card';
import Scrollbar from 'src/minimal-components/scrollbar';
import {PulseLoader} from 'react-spinners';
import {date} from 'yup';
import SelectInput from '@components/form/select-input/SelectInput';

interface UserGroupInterface {
  refreshTrigger?: boolean;
  setRefreshPage?: (value: boolean) => void;
  setRefreshUserGroup?: (value: boolean) => void;
  userGroupsync?: boolean;
  setUserGroupsync?: (value: boolean) => void;
}

const UserGroupsSettings = (props: UserGroupInterface): JSX.Element => {
  const [activeTab, setActiveTab] = React.useState<any>();
  const [userGroupList, setUserGroupList] = React.useState<any>({
    list: [],
    loader: true
  });
  const [podList, setPodList] = useState<any>([]);
  const [selectedPod, setSelectedPod] = useState();
  const [currentGroupItem, setCurrentGroupItem] = React.useState<any>();
  const [loader, setLoader] = React.useState<boolean>(true);
  const [roleList, setRoleList] = React.useState<any>([]);
  const [checkboxState, setCheckboxState] = React.useState<any>({
    originalData: {},
    changedData: {}
  });
  const [openDialog, setOpenDialog] = React.useState<boolean>(false);
  const [openDeleteDialog, setOpenDeleteDialog] =
    React.useState<boolean>(false);
  const [openAdDeleteDialog, setOpenAdDeleteDialog] =
    React.useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [nextSelectedUserGroupData, setNextSelectedUserGroupData] =
    React.useState({
      item: {},
      index: 0,
      roleRes: ''
    });
  const [submitLoader, setSubmitLoader] = React.useState<boolean>(false);
  const [isRolesOpen, setIsRolesOpen] = React.useState<boolean>(false);
  const [searchQuery, setSearchQuery] = React.useState<string>('');
  const [isAddingGroup, setIsAddingGroup] = React.useState<boolean>(false);
  const [checkmapadGroup, setCheckmapAdGroup] = React.useState(false);

  const params = new URLSearchParams(location.search);
  const [dialogInfo, setDialogInfo] = React.useState<any>({
    dialogTitle: '',
    dialogDescription: '',
    dialogNoteDescription: '',
    dialogNote: '',
    yesLabelText: '',
    noLabelText: '',
    yesButtonColor: '',
    noButtonColor: ''
  });
  const [dialogButtonLoader, setDialogButtonLoader] =
    React.useState<boolean>(false);
  const [groupName, setGroupName] = React.useState('');
  const [deleteadGrop, SetDeleteadGroup] = React.useState(false);
  const [ADGroupsList, setADGroupsList] = React.useState<any>([]);
  const [selectedADGroupsList, setSelectedADGroupsList] = React.useState<any>(
    []
  );
  const theme = useTheme();
  const [legacyAppsList, setLegacyAppsList] = React.useState<any>([]);
  const [selectedLegacyAppsList, setSelectedLegacyAppsList] =
    React.useState<any>([]);
  const [openAddADGroupPopup, setOpenAddADGroupPopup] =
    React.useState<boolean>(false);

  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {control, setValue} = useForm({
    mode: 'onBlur'
  });
  const {
    appState: {applicationName, hospitalId}
  } = useAppContext();

  const onUserGroupChange = async (
    item: any,
    userGroupIndex: number,
    rolesRes?: any,
    name?: any
  ) => {
    navigate(
      `/${BASE_ROUTE}/${UAM}?${FormConstants.USER_ACCESS.SELECTED_TAB}=${params.get('selected_tab')}&${
        FormConstants.USER_ACCESS.USER_GROUPS + '='
      }&${FormConstants.USER_ACCESS.SELECTED_GROUP}=${name}`,
      {
        state: {}
      }
    );

    setIsRolesOpen(true);

    setActiveTab(userGroupIndex);
    setCurrentGroupItem(item);

    try {
      if (selectedPod !== '' && selectedPod !== undefined) {
        const res: any = await getUserGroupRolesData(
          userGroupIndex,
          selectedPod || ''
        );

        const allRolesData: any = rolesRes ? rolesRes : {};
        for (const Item of res.data.roles) {
          allRolesData[Item.id] = true;
        }

        setCheckboxState((prevState: any) => ({
          ...prevState,
          originalData: allRolesData,
          changedData: {}
        }));

        setIsRolesOpen(false);

        if (res?.ad_groups_list?.length > 0) {
          const list: any[] = [];
          for (const ele of res.ad_groups_list) {
            list.push(ele?.azure_ad_group_id);
          }
          setSelectedADGroupsList(list);
        }

        if (res?.legacy_apps_list?.length > 0) {
          const list: any[] = [];
          for (const ele of res.legacy_apps_list) {
            list.push(ele?.legacy_app_id);
          }
          setSelectedLegacyAppsList(list);
        }
      }
    } catch (error) {
      setIsRolesOpen(false);
      const {message}: any = error;
      enqueueSnackbar(message, SnackBarConfig.getError());
    } finally {
      setUserGroupList((prevState: any) => ({
        ...prevState,
        loader: false
      }));
    }
  };

  const getAndUpdateUserGroups = async () => {
    try {
      const description = FormConstants.COMMON.VIEWED_USER_GROUPS;
      if (podList.length === 0) {
        const {data} = await getApplicationListData();
        const value = data.filter((val: any) => val.application_name);
        setPodList(value);
        setSelectedPod(value[0]?.application_name);

        const groupListRes = await getUserGroupList(
          searchQuery,
          description,
          data[0]?.application_name
        );
        const {rows} = groupListRes.data;

        setLoader(false);
        setUserGroupList((prevState: any) => ({
          ...prevState,
          list: rows
        }));

        if (rows.length !== 0) {
          setRoleList([]);
          const allRolesList = await getRoleList(
            '',
            '',
            data[0]?.application_name
          );
          setRoleList(allRolesList?.data?.rows);

          setADGroupsList([]);
          setLegacyAppsList([]);
          const res = await getADGroupsList(data[0]?.application_name);
          setADGroupsList(res?.data?.groups);
          setLegacyAppsList(res?.data?.legacy_apps);

          let allRolesData: any = {};
          for (const item of allRolesList.data.rows) {
            const obj: any = {
              [item?.id]: false
            };
            allRolesData = {...allRolesData, ...obj};
          }

          setCheckboxState((prevState: any) => ({
            ...prevState,
            originalData: allRolesData
          }));

          const userGroup = AuthUtils.getUserAccess();
          if (rows?.[0]) {
            if (userGroup) {
              const result = rows.find((item: any) => item.name === userGroup);
              onUserGroupChange(result, result?.id, allRolesData, result?.name);
              AuthUtils.clearUserAccess();
            } else {
              onUserGroupChange(
                rows?.[0],
                rows[0]?.id,
                allRolesData,
                rows?.[0]?.name
              );
            }
          }
          setUserGroupList((prevState: any) => ({
            ...prevState,
            loader: false
          }));
        } else if (rows.length === 0) {
          setUserGroupList((prevState: any) => ({
            ...prevState,
            loader: true
          }));

          setRoleList([]);
          setActiveTab(null);
          setCurrentGroupItem('');

          setUserGroupList((prevState: any) => ({
            ...prevState,
            loader: false
          }));
        }
      }
      if (selectedPod !== '' && selectedPod !== undefined) {
        const groupListRes = await getUserGroupList(
          searchQuery,
          description,
          selectedPod
        );
        const {rows} = groupListRes.data;

        setLoader(false);
        setUserGroupList((prevState: any) => ({
          ...prevState,
          list: rows
        }));

        if (rows.length !== 0) {
          setRoleList([]);
          const allRolesList = await getRoleList('', '', selectedPod);
          setRoleList(allRolesList?.data?.rows);

          setADGroupsList([]);
          setLegacyAppsList([]);
          const res = await getADGroupsList(selectedPod);
          setADGroupsList(res?.data?.groups);
          setLegacyAppsList(res?.data?.legacy_apps);

          let allRolesData: any = {};
          for (const item of allRolesList.data.rows) {
            const obj: any = {
              [item?.id]: false
            };
            allRolesData = {...allRolesData, ...obj};
          }

          setCheckboxState((prevState: any) => ({
            ...prevState,
            originalData: allRolesData
          }));

          const userGroup = AuthUtils.getUserAccess();
          if (rows?.[0]) {
            if (userGroup) {
              const result = rows.find((item: any) => item.name === userGroup);
              onUserGroupChange(result, result?.id, allRolesData, result?.name);
              AuthUtils.clearUserAccess();
            } else {
              onUserGroupChange(
                rows?.[0],
                rows[0]?.id,
                allRolesData,
                rows?.[0]?.name
              );
            }
          }
          setUserGroupList((prevState: any) => ({
            ...prevState,
            loader: false
          }));
        } else if (rows.length === 0) {
          setUserGroupList((prevState: any) => ({
            ...prevState,
            loader: true
          }));

          setRoleList([]);
          setActiveTab(null);
          setCurrentGroupItem('');

          setUserGroupList((prevState: any) => ({
            ...prevState,
            loader: false
          }));
        }
      }
    } catch (error) {
      setUserGroupList((prevState: any) => ({
        ...prevState,
        loader: false
      }));
      setLoader(false);
      const {message}: any = error;
      enqueueSnackbar(message, SnackBarConfig.getError());
    }
  };

  React.useEffect(() => {
    // if (
    //   props.setRefreshUserGroup &&
    //   typeof props.setRefreshUserGroup === 'function'
    // ) {
    //   props.setRefreshUserGroup(false);
    // }

    getAndUpdateUserGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery, selectedPod]);

  React.useEffect(() => {
    if (selectedADGroupsList.length > 0) {
      SetDeleteadGroup(true);
    } else {
      SetDeleteadGroup(false);
    }
  }, [selectedADGroupsList]);

  const handleUserGroupChange = (item: any, index: any, name: any) => {
    if (
      checkboxState.changedData &&
      Object.keys(checkboxState.changedData).length > 0
    ) {
      if (index !== activeTab) {
        setOpenDialog(true);
        setNextSelectedUserGroupData((prevState: any) => ({
          ...prevState,
          item,
          index
        }));
      }
    } else if (index !== activeTab) {
      navigate(
        `/${BASE_ROUTE}/${UAM}?${FormConstants.USER_ACCESS.SELECTED_TAB}=${params.get('selected_tab')}&${
          FormConstants.USER_ACCESS.USER_GROUPS + '='
        }&${FormConstants.USER_ACCESS.SELECTED_GROUP}=${name}`,
        {
          state: {}
        }
      );
      setSelectedADGroupsList([]);
      setSelectedLegacyAppsList([]);
      onUserGroupChange(item, item.id, '', item.name);
    }

    setIsAddingGroup(false);
  };

  const handleCancel = () => {
    if (isAddingGroup) {
      if (
        checkboxState.changedData &&
        Object.keys(checkboxState.changedData).length > 0
      ) {
        setOpenDialog(true);
      } else {
        setLoader(true);
        getAndUpdateUserGroups();
        setIsAddingGroup(false);
      }
    } else if (
      checkboxState.changedData &&
      Object.keys(checkboxState.changedData).length > 0
    ) {
      setOpenDialog(true);
      setNextSelectedUserGroupData((prevState: any) => ({
        ...prevState,
        item: currentGroupItem,
        index: currentGroupItem?.id,
        roleRes: ''
      }));
    } else {
      if (checkmapadGroup) {
        setOpenDialog(true);
      }
      setNextSelectedUserGroupData((prevState: any) => ({
        ...prevState,
        item: currentGroupItem,
        index: currentGroupItem?.id,
        roleRes: ''
      }));
    }
  };
  const handleUpdateUserGroups = async (updatedRoles: Array<number>) => {
    try {
      if (isAddingGroup) {
        const res = await addNewGroup(
          {
            group_name: groupName || currentGroupItem.name,
            roles_list: updatedRoles,
            ad_groups_list: selectedADGroupsList,
            legacy_apps_list: selectedLegacyAppsList
          },
          selectedPod || ''
        );

        setSubmitLoader(false);
        enqueueSnackbar(res?.message, SnackBarConfig.getSuccess());
        setLoader(true);
        setIsAddingGroup(false);
        getAndUpdateUserGroups();
      } else {
        const updateRes = await updateUserGroupRolesData(
          currentGroupItem?.id,
          {
            action: FormConstants.USER_GROUP.BY_ROLE,
            group_name: groupName || currentGroupItem.name,
            role_ids: updatedRoles,
            ad_groups_list: selectedADGroupsList,
            legacy_apps_list: selectedLegacyAppsList
          },
          selectedPod || ''
        );
        const list = userGroupList?.list;
        const UserGroupObjIndex: number = userGroupList?.list?.findIndex(
          (role: any) => role.name === currentGroupItem?.name
        );

        if (UserGroupObjIndex > -1) {
          list[UserGroupObjIndex].name = groupName || currentGroupItem?.name;
        }
        setUserGroupList((prevState: any) => ({
          ...prevState,
          list
        }));
        setSubmitLoader(false);
        enqueueSnackbar(updateRes?.message, SnackBarConfig.getSuccess());
      }
    } catch (error) {
      setSubmitLoader(false);
      const {message}: any = error;
      enqueueSnackbar(message, SnackBarConfig.getError());
    }
  };

  const handleUpdateDeleteAdUserGroups = async (
    updatedRoles: Array<number>
  ) => {
    setDialogButtonLoader(true);
    try {
      const updateRes = await updateUserGroupRolesData(
        currentGroupItem?.id,
        {
          action: FormConstants.USER_GROUP.SOFT_DELETE_BY_ROLE,
          role_ids: updatedRoles,
          ad_groups_list: selectedADGroupsList,
          legacy_apps_list: selectedLegacyAppsList
        },
        selectedPod || ''
      );
      setSubmitLoader(false);
      setDialogButtonLoader(false);
      setOpenAdDeleteDialog(false);
      enqueueSnackbar(updateRes?.message, SnackBarConfig.getSuccess());
    } catch (error) {
      setSubmitLoader(false);
      const {message}: any = error;
      enqueueSnackbar(message, SnackBarConfig.getError());
    }
  };

  const handleSubmit = () => {
    setCheckmapAdGroup(false);
    setSubmitLoader(true);
    const updatedRoles: Array<number> = [];
    Object.entries(checkboxState?.originalData).forEach(([id, value]: any) => {
      if (value) updatedRoles.push(id);
    });

    handleUpdateUserGroups([...updatedRoles]);

    setCheckboxState((prevState: any) => ({
      ...prevState,
      changedData: {}
    }));
  };

  const handleChange = (
    id: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const checkedData = checkboxState?.originalData;
    checkedData[id] = event.target.checked;

    let currentRole: any = {};
    let isExist = false;

    Object.entries(checkboxState?.changedData).forEach(
      ([changedRoleId, value]: any) => {
        if (id?.toString() === changedRoleId?.toString()) {
          isExist = true;
        }
      }
    );

    if (isExist) {
      Object.entries(checkboxState?.changedData).forEach(
        ([changedRoleId, value]: any) => {
          let obj = {};
          if (id?.toString() !== changedRoleId?.toString()) {
            obj = {[changedRoleId]: value};
          }
          currentRole = {...currentRole, ...obj};
        }
      );
    } else {
      currentRole = {
        ...checkboxState?.changedData,
        [id]: event.target.checked
      };
    }

    setCheckboxState((prevState: any) => ({
      ...prevState,
      originalData: checkedData,
      changedData: currentRole
    }));
  };

  const checkKeyExistence = (id: any, list: any): boolean => {
    return list.includes(id);
  };

  const handleCheckBoxesChange = (
    id: number,
    event: React.ChangeEvent<HTMLInputElement>,
    selectedList: any,
    setSelectedList: any
  ): void => {
    const isGroupAlreadyExisted = checkKeyExistence(id, selectedList);
    setCheckmapAdGroup(true);

    if (event.target.checked) {
      if (!isGroupAlreadyExisted) {
        const list = [...selectedList];
        list.push(id);
        setSelectedList(list);
      }
    } else {
      if (isGroupAlreadyExisted) {
        const list = selectedList.filter((item: any) => item !== id);
        setSelectedList(list);
      }
    }
  };

  const handleOpenRolesDetails = async (item: any, roleIndex: number) => {
    AuthUtils.setUserAccess(item.name);
    navigate(
      `/${BASE_ROUTE}/${UAM}?${FormConstants.USER_ACCESS.SELECTED_TAB}=roles&${
        FormConstants.USER_ACCESS.ROLES + '=' + `${selectedPod}`
      }&${FormConstants.USER_ACCESS.SELECTED_ROLE}=${item.name}`,
      {
        state: {}
      }
    );

    if (
      props.setRefreshUserGroup &&
      typeof props.setRefreshUserGroup === 'function'
    ) {
      props.setRefreshUserGroup(true);
    }
  };

  const handleAgreeBtnClick = () => {
    setCheckmapAdGroup(false);
    getAndUpdateUserGroups();
    setOpenDialog(false);
    setIsAddingGroup(false);
  };

  const handleAgreeAdButtonClick = async () => {
    if (openAdDeleteDialog) {
      const updatedRoles: Array<number> = [];
      Object.entries(checkboxState?.originalData).forEach(
        ([id, value]: any) => {
          if (value) updatedRoles.push(id);
        }
      );

      handleUpdateDeleteAdUserGroups([...updatedRoles]);

      setCheckboxState((prevState: any) => ({
        ...prevState,
        changedData: {}
      }));
    }
  };

  const handleDeleteAgreeBtnClick = async () => {
    if (openDeleteDialog) {
      try {
        setDialogButtonLoader(true);
        const data = await validateDeleteGroup(
          currentGroupItem?.id,
          selectedPod || ''
        );
        setDialogButtonLoader(false);
        if (data?.is_valid_request) {
          const res = await deleteGroup(currentGroupItem?.id, {});
          enqueueSnackbar(res?.message, SnackBarConfig.getSuccess());
          setOpenDeleteDialog(false);

          setLoader(true);
          getAndUpdateUserGroups();
        } else {
          setDialogInfo({
            dialogTitle: `${t(
              'PRIVATE.ROLES.DELETE_GROUPS_ERROR_DIALOG.TITLE',
              {
                ns: 'private'
              }
            )}`,
            dialogDescription: `${t(
              `${currentGroupItem?.name} is assigned to Users, Please un assign the Users and delete the group again`,
              {
                ns: 'private'
              }
            )}`,
            noLabelText: `${t(
              'PRIVATE.ROLES.DELETE_ROLES_ERROR_DIALOG.NO_LABEL_TEXT',
              {
                ns: 'private'
              }
            )}`,
            noButtonColor: APP.PALETTE.ROLES.GRAY
          });
        }
      } catch (error) {
        const {message}: any = error;
        enqueueSnackbar(message, SnackBarConfig.getError());
        setOpenDeleteDialog(false);
        setDialogButtonLoader(false);
      }
    }
  };

  const handleCloseBtnClick = () => {
    setOpenDialog(false);
  };

  const handleChangeText = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
    // if (e.target.value.length > 2) {
    //   setSearchQuery(e.target.value);
    // } else {
    //   setSearchQuery('');
    // }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedChangeHandler = React.useCallback(
    debounce(handleChangeText, 300),
    []
  );

  const handleGroupDelete = async () => {
    setOpenDeleteDialog(true);

    setDialogInfo({
      dialogTitle: `${t('PRIVATE.ROLES.DELETE_DIALOG.TITLE', {ns: 'private'})}`,
      dialogDescription:
        `${t('PRIVATE.ROLES.DELETE_DIALOG.DESCRIPTION', {ns: 'private'})}` +
        ' ' +
        currentGroupItem?.name +
        '?',
      yesLabelText: `${t('PRIVATE.ROLES.DELETE_DIALOG.YES_LABEL_TEXT', {
        ns: 'private'
      })}`,
      yesButtonColor: APP.PALETTE.ROLES.RED,
      noLabelText: `${t('PRIVATE.ROLES.DELETE_DIALOG.NO_LABEL_TEXT', {
        ns: 'private'
      })}`,
      noButtonColor: APP.PALETTE.ROLES.GRAY
    });
  };
  const handleMapAdGroupDelete = async () => {
    setOpenAdDeleteDialog(true);
    const filteredNames = ADGroupsList.filter((obj: any) =>
      selectedADGroupsList.includes(obj.ID)
    ).map((obj: any) => obj.Name);

    const names = userGroupList.list.map((item: any) => item.name);

    setDialogInfo({
      dialogTitle: `${t('PRIVATE.ROLES.DELETE_DIALOG2.TITLE', {
        ns: 'private'
      })}`,
      dialogDescription: (
        <div>
          <Typography>
            {t('PRIVATE.ROLES.DELETE_DIALOG2.DESCRIPTION', {
              ns: 'private'
            })}{' '}
            {filteredNames.join(', ')} ?
          </Typography>
          <Typography component="p" fontWeight="bold" marginTop="10px">
            {t('PRIVATE.ROLES.DELETE_DIALOG2.NOTE_STRONG', {
              ns: 'private'
            })}
          </Typography>
          <Typography>
            {t('PRIVATE.ROLES.DELETE_DIALOG2.NOTE_DESCRIPTION_BEFORE', {
              ns: 'private'
            })}{' '}
            {names.join(', ')}.
            {t('PRIVATE.ROLES.DELETE_DIALOG2.NOTE_DESCRIPTION_AFTER', {
              ns: 'private'
            })}
          </Typography>
        </div>
      ),
      yesLabelText: `${t('PRIVATE.ROLES.DELETE_DIALOG2.YES_LABEL_TEXT', {
        ns: 'private'
      })}`,
      yesButtonColor: APP.PALETTE.ROLES.RED,
      noLabelText: `${t('PRIVATE.ROLES.DELETE_DIALOG2.NO_LABEL_TEXT', {
        ns: 'private'
      })}`,
      noButtonColor: APP.PALETTE.ROLES.GRAY
    });
  };

  const renderUserGroupList = (item: any, index: number) => {
    return (
      <List
        key={item?.id}
        sx={{
          bgcolor: 'background.paper',
          width: '100%',
          padding: 0,
          flex: 1,
          flexWrap: 'nowrap'
        }}>
        <ListItem key={index} disablePadding sx={{display: 'block'}}>
          <ListItemButton
            sx={{
              px: 2.5,
              py: 1.5,
              typography: 'subtitle2',
              wordBreak: 'break-all'
            }}
            selected={index === activeTab}
            onClick={() => {
              handleUserGroupChange(item, item.id, item.name);
            }}
            style={{
              backgroundColor: index === activeTab ? 'white' : 'none',
              borderRight:
                index === activeTab
                  ? `5px solid ${theme.palette.primary.dark}`
                  : `5px solid ${theme.palette.common.white}`
            }}
            // autoFocus={index === activeTab ? true : false}
          >
            <ListItemText
              primaryTypographyProps={{
                style: {
                  color:
                    index === activeTab
                      ? theme.palette.primary.dark
                      : theme.palette.common.black
                },
                fontSize: 15
              }}
              primary={
                isAddingGroup && index === activeTab
                  ? item?.name + `*`
                  : item?.name
              }
            />
          </ListItemButton>
        </ListItem>
        <Divider style={{width: '100%'}} />
      </List>
    );
  };

  const renderButtons = () => {
    return (
      <ButtonsGrid>
        <div style={{paddingRight: 6}}>
          <SelectInput
            enableDefaultOption
            options={podList}
            placeholder={'selected Pod'}
            name={'selectedPod'}
            value={selectedPod || ''}
            fullWidth
            onChange={(event: any) => {
              setSelectedPod(event.target.value);
            }}
            optionValueKey={'application_name'}
            optionLabelKey={'name'}
            // disabled={
            //   (params.module_name === FormConstants.SCREENS.FINANCE &&
            //     uiFieldsData.menu_item ===
            //       FormConstants.REPORTS_SCREENS.REPORTS) ||
            //   ((params.module_name === FormConstants.SCREENS.LIS ||
            //     params.module_name === FormConstants.SCREENS.RIS) &&
            //     uiFieldsData.name ===
            //       FormConstants.GLOBAL_SEARCH.global_search_tab)
            //     ? inputName !== FormConstants.INPUT_FIELD_NAMES.SOURCE_SYSTEM &&
            //       !optionsList.length
            //       ? true
            //       : false
            //     : false
            // }
            sx={{marginRight: 1}}
          />
        </div>
        {activeTab ? (
          <>
            <LoadingButton
              type="submit"
              variant="contained"
              color="error"
              disabled={submitLoader || isAddingGroup}
              sx={{
                mr: 1,
                bgcolor: theme.palette.primary.lighter
              }}
              onClick={handleGroupDelete}>
              {t('PRIVATE.ROLES.DELETE', {ns: 'private'})}
            </LoadingButton>
            <LoadingButton
              type="submit"
              variant="outlined"
              onClick={handleCancel}
              sx={{
                mr: 1,
                bgcolor: theme.palette.primary.light
                // backgroundColor: APP.PALETTE.COMMON.WHITE,
                // borderColor: APP.PALETTE.MODULE_LAYOUT_COLOR.RED_BUTTON,
                // '&:hover': {
                //   border: '1px solid',
                //   borderColor: APP.PALETTE.MODULE_LAYOUT_COLOR.RED_BUTTON
                // }
              }}
              disabled={submitLoader}>
              {t('PRIVATE.USER_GROUPS.CANCEL', {ns: 'private'})}
            </LoadingButton>
            <LoadingButton
              type="submit"
              variant="contained"
              loading={submitLoader}
              onClick={handleSubmit}
              sx={{
                mr: 1,
                bgcolor: theme.palette.primary.dark
                // backgroundColor: `${APP.PALETTE.MODULE_LAYOUT_COLOR.BUTTON}`,
                // '&:hover': {
                //   backgroundColor: `${APP.PALETTE.MODULE_LAYOUT_COLOR.HOVER_BUTTON}`
                // }
              }}
              disabled={submitLoader}>
              {t('PRIVATE.USER_GROUPS.SAVE', {ns: 'private'})}
            </LoadingButton>
          </>
        ) : null}
      </ButtonsGrid>
    );
  };

  const renderRoleList = (item: any, index: any): ReactElement => {
    return (
      <RoleItemGrid key={index}>
        <FormGroup key={index}>
          <FormControlLabel
            label={
              <span
                style={{
                  fontWeight: 'normal',
                  fontSize: '18px',
                  overflow: 'none',
                  wordBreak: 'break-all'
                }}>
                {item?.name}
              </span>
            }
            control={
              <Checkbox
                sx={{fontSize: '5rem', color: APP.PALETTE.USER_GROUP.GRAY_2}}
                checked={!!checkboxState?.originalData?.[item.id]}
                onChange={e => handleChange(item.id, e)}
                name={`${item.name}`}
              />
            }
          />
        </FormGroup>

        <DetailsGrid onClick={() => handleOpenRolesDetails(item, item.id)}>
          {t('PRIVATE.USER_GROUPS.DETAILS', {ns: 'private'})}
        </DetailsGrid>
      </RoleItemGrid>
    );
  };

  const renderADGroupList = (item: any, index: any): ReactElement => {
    return (
      <RoleItemGrid key={index}>
        <FormGroup key={index}>
          <FormControlLabel
            label={
              <span
                style={{
                  fontWeight: 'normal',
                  fontSize: '18px',
                  overflow: 'none',
                  wordBreak: 'break-all'
                }}>
                {item?.Name}
              </span>
            }
            control={
              <Checkbox
                sx={{fontSize: '5rem', color: APP.PALETTE.USER_GROUP.GRAY_2}}
                checked={checkKeyExistence(item?.ID, selectedADGroupsList)}
                onChange={e =>
                  handleCheckBoxesChange(
                    item?.ID,
                    e,
                    selectedADGroupsList,
                    setSelectedADGroupsList
                  )
                }
                name={`${item.Name}`}
              />
            }
          />
        </FormGroup>
      </RoleItemGrid>
    );
  };

  const renderLegacyAppsList = (item: any, index: any): ReactElement => {
    return (
      <RoleItemGrid key={index}>
        <FormGroup key={index}>
          <FormControlLabel
            label={
              <span
                style={{
                  fontWeight: 'normal',
                  fontSize: '18px',
                  overflow: 'none',
                  wordBreak: 'break-all'
                }}>
                {item?.LegacyApp}
              </span>
            }
            control={
              <Checkbox
                sx={{fontSize: '5rem', color: APP.PALETTE.USER_GROUP.GRAY_2}}
                checked={checkKeyExistence(item?.ID, selectedLegacyAppsList)}
                onChange={e =>
                  handleCheckBoxesChange(
                    item.ID,
                    e,
                    selectedLegacyAppsList,
                    setSelectedLegacyAppsList
                  )
                }
                name={`${item.LegacyApp}`}
              />
            }
          />
        </FormGroup>
      </RoleItemGrid>
    );
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleChangeTextField = (e: any) => {
    setValue(currentGroupItem.name, e.target.value);
    setGroupName(e.target.value);
  };

  const handleNewGroupClick = () => {
    setIsAddingGroup(true);

    const newID = Date.now();
    const str = newID.toString();
    const resultID = str.substring(0, 5);

    const newGroupObj = {
      id: resultID,
      name: NEW_GROUP_NAME
    };
    setActiveTab(newGroupObj.id);

    const list = userGroupList.list;
    list.push(newGroupObj);

    setUserGroupList((prevState: any) => ({
      ...prevState,
      list
    }));

    setCurrentGroupItem(newGroupObj);
    setCheckboxState((prevState: any) => ({
      ...prevState,
      originalData: {},
      changedData: {}
    }));
    setSelectedADGroupsList([]);
    setSelectedLegacyAppsList([]);
  };

  const dialogClose = () => {
    setOpenDeleteDialog(false);
    setOpenAdDeleteDialog(false);
  };

  const handleNewADGroupClick = (): void => {
    setOpenAddADGroupPopup(true);
  };

  const onADGroupClose = async (id?: any) => {
    setOpenAddADGroupPopup(false);
    if (typeof id === 'number') {
      const res = await getADGroupsList(selectedPod || '');
      setADGroupsList(res?.data?.groups);
      setLegacyAppsList(res?.data?.legacy_apps);
    }
  };

  const renderSection = (status: any) => {
    switch (status) {
      case isRolesOpen:
        return (
          <RoleAndPermissionsLoaderContainerGrid>
            <ComponentLoader />
          </RoleAndPermissionsLoaderContainerGrid>
        );
      case activeTab:
        return (
          <RoleAndPermissionsContainerGrid container item xs={12}>
            {!isRolesOpen && roleList.length !== 0 ? (
              <RoleGrid
                container
                item
                xs={3.5}
                wrap="nowrap"
                sx={{minWidth: '287px'}}>
                <span
                  style={{
                    fontWeight: 'normal',
                    fontSize: '18px',
                    padding: '0.5rem'
                  }}>
                  {FormConstants.USER_GROUP.ROLES_IN_THIS_GROUP}
                </span>

                <Divider style={{width: '100%'}} />

                {roleList.map((item: any) => renderRoleList(item, item.id))}
              </RoleGrid>
            ) : (
              ''
            )}

            <AdGroupGrid item xs={3.5} sx={{marginLeft: '2rem'}}>
              <Grid container spacing={1}>
                <RoleItemGrid
                  item
                  xs
                  style={{
                    fontWeight: 'normal',
                    fontSize: '18px',
                    padding: '0.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                  {t('PRIVATE.USER_GROUPS.MAP_AD_GROUPS', {ns: 'private'})}
                </RoleItemGrid>
                <RoleItemGrid>
                  <LoadingButton
                    type="submit"
                    variant="contained"
                    color="success"
                    sx={{
                      ml: 2,
                      width: '5.4rem',
                      bgcolor: theme.palette.primary.main
                    }}
                    onClick={handleNewADGroupClick}>
                    {t('PRIVATE.ROLES.ADD_GROUP_TEXT', {ns: 'private'})}
                  </LoadingButton>
                  {deleteadGrop && (
                    <LoadingButton
                      type="submit"
                      variant="contained"
                      disabled={submitLoader || isAddingGroup}
                      onClick={handleMapAdGroupDelete}
                      color="error"
                      sx={{
                        mr: 2,
                        bgcolor: theme.palette.primary.lighter
                      }}>
                      {/* <Iconify icon="solar:trash-bin-trash-bold" /> */}
                      {t('PRIVATE.ROLES.DELETE', {ns: 'private'})}
                    </LoadingButton>
                  )}
                </RoleItemGrid>
              </Grid>

              <Divider style={{width: '100%', marginTop: '0.5rem'}} />

              {ADGroupsList.map((item: any) =>
                renderADGroupList(item, item.ID)
              )}
            </AdGroupGrid>

            <RoleGrid item xs={3.5} sx={{marginLeft: '2rem'}}>
              <div
                style={{
                  fontWeight: 'normal',
                  fontSize: '18px',
                  padding: '0.5rem'
                }}>
                {t('PRIVATE.USER_GROUPS.MAP_LEGACY_APPS', {ns: 'private'})}
              </div>

              <Divider style={{width: '100%'}} />

              {legacyAppsList.map((item: any) =>
                renderLegacyAppsList(item, item.ID)
              )}
            </RoleGrid>
          </RoleAndPermissionsContainerGrid>
        );
      default:
        return (
          <NoRoleAndPermissionsContainerGrid>
            <Typography
              variant="h2"
              sx={{color: APP.PALETTE.USER_GROUP.GRAY_1}}>
              {t('PRIVATE.USER_GROUPS.NO_USER_GROUPS', {ns: 'private'})}
            </Typography>
          </NoRoleAndPermissionsContainerGrid>
        );
    }
  };

  const renderRolePermissionSection = (): ReactElement => {
    return (
      <RightGrid item xs={9.5}>
        <TopActionGrid>
          {currentGroupItem?.name ? (
            <RoleNameTypographyGrid>
              {activeTab && currentGroupItem && (
                <Controller
                  key={`${currentGroupItem?.name}`}
                  name={`${currentGroupItem?.name}`}
                  control={control}
                  render={({field, fieldState: {error}}) => (
                    <TextInput
                      size="small"
                      sx={{
                        '& legend': {display: 'none'},
                        '& fieldset': {top: 0},
                        backgroundColor: 'white'
                      }}
                      variant="outlined"
                      name={currentGroupItem?.name}
                      type={''}
                      error={!!error}
                      defaultValue={currentGroupItem?.name}
                      field={field}
                      onChange={e => handleChangeTextField(e)}
                    />
                  )}
                />
              )}
            </RoleNameTypographyGrid>
          ) : (
            ''
          )}
          <ActionButtonGrid>{renderButtons()}</ActionButtonGrid>
        </TopActionGrid>
        <Divider style={{width: '100%'}} />
        <RoleAndPermissionsWrapperGrid>
          {renderSection(
            isRolesOpen || activeTab || userGroupList?.list?.length === 0
          )}
        </RoleAndPermissionsWrapperGrid>
      </RightGrid>
    );
  };

  const renderSearchField = (): React.ReactElement => {
    return (
      <Search
        handleChangeText={debouncedChangeHandler}
        fieldName={t('PRIVATE.USER_GROUPS.USER_GROUPS_SEARCH_FORM', {
          ns: 'private'
        })}
        submitLoading={submitLoader}
        placeHolder={t('PRIVATE.USER_GROUPS.SEARCH_USER_GROUP', {
          ns: 'private'
        })}
        searchQuery={searchQuery}
      />
    );
  };

  const renderLeftSectionGroups = (): ReactElement => {
    return (
      <>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          sx={{
            pr: 1.5,
            pl: 1.5,
            pt: 0.5,
            pb: 0.5,
            height: `6.6vh`,
            borderBottom: `solid 1px ${theme.palette.divider}`
          }}>
          <h4
            style={{display: 'flex', marginLeft: '0.5rem', flexWrap: 'nowrap'}}>
            {t('PRIVATE.USER_GROUPS.USER_GROUPS_HEADING', {ns: 'private'})}
          </h4>
          <Box sx={{flexGrow: 1}} />
          <LoadingButton
            variant="contained"
            disabled={isAddingGroup}
            color="success"
            sx={{
              mr: 1,
              bgcolor: theme.palette.primary.main
            }}
            onClick={handleNewGroupClick}>
            {t('PRIVATE.ROLES.ADD_GROUP_TEXT', {ns: 'private'})}
          </LoadingButton>
        </Stack>
        <Box sx={{p: 2.5}}>{renderSearchField()}</Box>
        {/* <Scrollbar
          sx={{
            pb: 1,
            minHeight: '100vh',
            overflowY: 'auto',
            scrollbarWidth: 'none'
          }}>
          {userGroupList.loader ? (
            <UserGroupListLoaderGrid>
              <ComponentLoader />
            </UserGroupListLoaderGrid>
          ) : (
            userGroupList?.list?.map((item: any) =>
              renderUserGroupList(item, item.id)
            )
          )}
        </Scrollbar> */}
        <UserGroupListContainer>
          {userGroupList.loader ? (
            <UserGroupListLoaderGrid>
              <ComponentLoader />
            </UserGroupListLoaderGrid>
          ) : (
            userGroupList?.list?.map((item: any) =>
              renderUserGroupList(item, item.id)
            )
          )}
        </UserGroupListContainer>
      </>
    );
  };

  const renderDialog = (dialogProps: any): ReactElement => {
    return <ActionModalDialog {...dialogProps} />;
  };

  return (
    <Stack
      component={Card}
      direction="row"
      sx={{margin: '0 24px', height: `79vh`}}>
      {!loader ? (
        <UserGroupsGrid container item xs={12}>
          <Stack
            sx={{
              height: 1,
              flexShrink: 0,
              width: `16.2vw`,
              borderRight: `solid 1px ${theme.palette.divider}`,
              transition: theme.transitions.create(['width'], {
                duration: theme.transitions.duration.shorter
              })
            }}>
            {renderLeftSectionGroups()}
          </Stack>
          {renderRolePermissionSection()}
        </UserGroupsGrid>
      ) : (
        <ComponentLoaderGrid>
          <PulseLoader color={theme.palette.primary.main} />
        </ComponentLoaderGrid>
      )}
      {openDialog && (
        <ActionModalDialog
          open={openDialog}
          onClose={() => {
            setOpenDialog(false);
          }}
          title={t('PRIVATE.USER_GROUPS.UNSAVED_CHANGES.TITLE', {
            ns: 'private'
          })}
          description={t('PRIVATE.USER_GROUPS.UNSAVED_CHANGES.DESCRIPTION', {
            ns: 'private'
          })}
          handleAgreeBtnClick={handleAgreeBtnClick}
          handleCloseBtnClick={handleCloseBtnClick}
          loader={false}
          yesLabelText={t(
            'PRIVATE.USER_GROUPS.UNSAVED_CHANGES.YES_LABEL_TEXT',
            {
              ns: 'private'
            }
          )}
          noLabelText={t('PRIVATE.USER_GROUPS.UNSAVED_CHANGES.NO_LABEL_TEXT', {
            ns: 'private'
          })}
          yesButtonColor={APP.PALETTE.ROLES.RED}
          noButtonColor={APP.PALETTE.ROLES.GRAY}
        />
      )}

      {(openDeleteDialog || openAdDeleteDialog) &&
        renderDialog({
          open: openDeleteDialog || openAdDeleteDialog,
          onClose: dialogClose,
          title: dialogInfo?.dialogTitle,
          description: dialogInfo?.dialogDescription,
          yesLabelText: dialogInfo?.yesLabelText,
          noLabelText: dialogInfo?.noLabelText,
          yesButtonColor: dialogInfo?.yesButtonColor,
          noButtonColor: dialogInfo?.noButtonColor,
          handleAgreeBtnClick: openDeleteDialog
            ? handleDeleteAgreeBtnClick
            : handleAgreeAdButtonClick,
          handleCloseBtnClick: dialogClose,
          loader: dialogButtonLoader
        })}

      {openAddADGroupPopup && (
        <AdGroupsAddDialog
          open={openAddADGroupPopup}
          onClose={onADGroupClose}
        />
      )}
    </Stack>
  );
};

export default UserGroupsSettings;
